import { render, staticRenderFns } from "./StockviewPricePositionFilter.vue?vue&type=template&id=63494872&"
import script from "./StockviewPricePositionFilter.vue?vue&type=script&lang=js&"
export * from "./StockviewPricePositionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports